module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/ashou9-f47ec36704a0231d252f0e749f640d63.jpg";